const defaultModalOverrides = "_uw7d10321si";
const contentWrapper = "_uw7c3hs3ce";
const gridWrapper = "_uw7gc7si3z";
const sliderWrapper = "_uw7sqwpf5f";
const componentFrameworkWrapper = "_uw7c1x1wlfw";
const withToolbarWrapper = "_uw7w1ku5031";
const withToolbarContainer = "_uw7wcqb5kz";
const fallbackWrapper = "_uw7f1j6ceg4";

export { componentFrameworkWrapper, contentWrapper, defaultModalOverrides, fallbackWrapper, gridWrapper, sliderWrapper, withToolbarContainer, withToolbarWrapper };
import "./pm2-modal.style.linaria.module.css";
//# sourceMappingURL=pm2-modal.style.js.map
